import { combineReducers } from 'redux';
import * as ActionTypes from '../actions/types';

const INITIAL_STATE = { sortBy: 'id', sortDesc: true };

const sort = ({ types }) => {
  if (!Array.isArray(types) || types.length !== 2) {
    throw new Error('Expected types to be an array of two elements.');
  }
  if (!types.every((type) => typeof type === 'string')) {
    throw new Error('Expected types to be strings.');
  }

  const [updateType, resetType] = types;

  return (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case updateType:
        return {
          sortBy: action.sortBy,
          sortDesc: action.sortDesc,
        };
      case resetType:
        return INITIAL_STATE;
      default:
        return state;
    }
  };
};

const sorting = combineReducers({
  clients: sort({
    types: [
      ActionTypes.UPDATE_CLIENTS_SORTING,
      ActionTypes.RESET_CLIENTS_SORTING,
    ],
  }),
  users: sort({
    types: [
      ActionTypes.UPDATE_USERS_SORTING,
      ActionTypes.RESET_USERS_SORTING,
    ],
  }),
  payments: sort({
    types: [
      ActionTypes.UPDATE_PAYMENTS_SORTING,
      ActionTypes.RESET_PAYMENTS_SORTING,
    ],
  }),
  terminals: sort({
    types: [
      ActionTypes.UPDATE_TERMINALS_SORTING,
      ActionTypes.RESET_TERMINALS_SORTING,
    ],
  }),
  cards: sort({
    types: [
      ActionTypes.UPDATE_CARDS_SORTING,
      ActionTypes.RESET_CARDS_SORTING,
    ],
  }),
  achs: sort({
    types: [
      ActionTypes.UPDATE_ACHS_SORTING,
      ActionTypes.RESET_ACHS_SORTING,
    ],
  }),
});

export default sorting;
